import { message, notification } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useIdempotency from "./useIdempotency";

const useMutation = ({
  idempotency = false,
  mutationFn,
  onSuccess,
  onError
}) => {
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const { getKey, resetKey } = useIdempotency();

  const mutate = async (...args) => {
    setLoading(true);

    try {
      let finalArgs = args;

      // si usa idempotencia → inyectar key
      if (idempotency) {
        const key = getKey();
        finalArgs = [...args, key]; // SIEMPRE como último argumento
      }

      const data = await mutationFn(...finalArgs);

      if (data.message === "invalid or expired jwt") {
        message.error({
          key: "TOKEN_INVALID",
          content: "La sesión ha expirado",
        });
        navigate("/login");
        return;
      }

      switch (data.status) {
        case "success":
          setData(data);
          onSuccess?.(data);
          if (idempotency) resetKey(); // Nueva key para la próxima acción real
          break;
        case "error":
          const isInProgress = data?.message?.includes("Solicitud ya en proceso") || data?.message?.includes("en proceso");
          if (!isInProgress) {
            throw new Error(data.message || "Error inesperado");
          } else {
            console.log("procesando")
          }
          break;
        default:
          throw new Error(`Status desconocido: ${data?.status}`);
      }
    } catch (error) {
      const isNetworkError = error instanceof TypeError;

      // FIX: en error de red NO resetear (permite reintentar con la misma key)
      if (isNetworkError) {
        notification.error({
          key: "NETWORK_ERROR",
          message: "El servicio no está disponible en este momento",
          placement: "top",
          duration: 0,
        });
        return;
      }

      // FIX: si el backend te devolvió "en proceso" (409), NO resetear la key
      // (ajustá el string/código a como te llegue en tu API)
      const msg = error?.message || "Error inesperado";
      
      // IMPROVE: en error lógico, normalmente sí conviene resetear
      if (idempotency) {
        resetKey();
      }

      const safeErr = error instanceof Error ? error : new Error(msg);
      safeErr.message = msg;

      setError(safeErr);
      onError?.(safeErr);
    } finally {
      setLoading(false);
    }
  }

  return { mutate, data, loading, error }
}

export default useMutation